'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _case = require('case');

var _case2 = _interopRequireDefault(_case);

var _has = require('lodash/has');

var _has2 = _interopRequireDefault(_has);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _mapKeys = require('lodash/mapKeys');

var _mapKeys2 = _interopRequireDefault(_mapKeys);

var _transform = require('lodash/transform');

var _transform2 = _interopRequireDefault(_transform);

var _mixed = require('./mixed');

var _mixed2 = _interopRequireDefault(_mixed);

var _locale = require('./locale.js');

var _sortFields = require('./util/sortFields');

var _sortFields2 = _interopRequireDefault(_sortFields);

var _sortByKeyOrder = require('./util/sortByKeyOrder');

var _sortByKeyOrder2 = _interopRequireDefault(_sortByKeyOrder);

var _inherits = require('./util/inherits');

var _inherits2 = _interopRequireDefault(_inherits);

var _runValidations = require('./util/runValidations');

var _runValidations2 = _interopRequireDefault(_runValidations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function unknown(ctx, value) {
  var known = Object.keys(ctx.fields);
  return Object.keys(value).filter(function (key) {
    return known.indexOf(key) === -1;
  });
}

/**
 * maintain "private" fields
 * `"__FOO_BAR"` becomes `"__fooBar"` not `"fooBar"`
 */
function camelize(str) {
  var result = _case2.default.camel(str),
      idx = str.search(/[^_]/);

  return idx === 0 ? result : str.substr(0, idx) + result;
}

module.exports = ObjectSchema;

function ObjectSchema(spec) {
  var _this2 = this;

  if (!(this instanceof ObjectSchema)) return new ObjectSchema(spec);

  _mixed2.default.call(this, { type: 'object', default: function _default() {
      var _this = this;

      var dft = (0, _transform2.default)(this._nodes, function (obj, key) {
        obj[key] = _this.fields[key].default ? _this.fields[key].default() : undefined;
      }, {});

      return Object.keys(dft).length === 0 ? undefined : dft;
    }
  });

  this.fields = Object.create(null);
  this._nodes = [];
  this._excludedEdges = [];

  this.withMutation(function () {
    _this2.transform(function coerce(value) {
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value);
        } catch (err) {
          value = null;
        }
      }
      if (this.isType(value)) return value;
      return null;
    });

    if (spec) {
      _this2.shape(spec);
    }
  });
}

(0, _inherits2.default)(ObjectSchema, _mixed2.default, {
  _typeCheck: function _typeCheck(value) {
    return isObject(value) || typeof value === 'function';
  },
  _cast: function _cast(_value) {
    var _this3 = this;

    var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var value = _mixed2.default.prototype._cast.call(this, _value, opts);

    //should ignore nulls here
    if (value === undefined) return this.default();

    if (!this._typeCheck(value)) return value;

    var fields = this.fields,
        strip = this._option('stripUnknown', opts) === true,
        extra = Object.keys(value).filter(function (v) {
      return _this3._nodes.indexOf(v) === -1;
    }),
        props = this._nodes.concat(extra);

    var innerOptions = _extends({}, opts, {
      parent: {}, // is filled during the transform below
      __validating: false
    });

    value = (0, _transform2.default)(props, function (obj, prop) {
      var field = fields[prop];
      var exists = (0, _has2.default)(value, prop);

      if (field) {
        var fieldValue = void 0;
        var strict = field._options && field._options.strict;

        if (field._strip === true) return;

        fieldValue = !opts.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];

        if (fieldValue !== undefined) obj[prop] = fieldValue;
      } else if (exists && !strip) obj[prop] = value[prop];
    }, innerOptions.parent);

    return value;
  },
  _validate: function _validate(_value) {
    var _this4 = this;

    var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var errors = [],
        endEarly,
        recursive;

    endEarly = this._option('abortEarly', opts);
    recursive = this._option('recursive', opts);

    opts = _extends({}, opts, { __validating: true });

    return _mixed2.default.prototype._validate.call(this, _value, opts).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !isObject(value)) {
        // only iterate though actual objects
        if (errors.length) throw errors[0];
        return value;
      }

      var validations = _this4._nodes.map(function (key) {
        var path = (opts.path ? opts.path + '.' : '') + key,
            field = _this4.fields[key],
            innerOptions = _extends({}, opts, { path: path, parent: value });

        if (field) {
          // inner fields are always strict:
          // 1. this isn't strict so we just cast the value leaving nested values already cast
          // 2. this is strict in which case the nested values weren't cast either
          innerOptions.strict = true;

          if (field.validate) return field.validate(value[key], innerOptions);
        }

        return true;
      });

      return (0, _runValidations2.default)({
        validations: validations,
        value: value,
        errors: errors,
        endEarly: endEarly,
        path: opts.path,
        sort: (0, _sortByKeyOrder2.default)(_this4.fields)
      });
    });
  },
  concat: function concat(schema) {
    var next = _mixed2.default.prototype.concat.call(this, schema);

    next._nodes = (0, _sortFields2.default)(next.fields, next._excludedEdges);

    return next;
  },
  shape: function shape(schema) {
    var excludes = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];

    var next = this.clone(),
        fields = _extends(next.fields, schema);

    if (!Array.isArray(excludes[0])) excludes = [excludes];

    next.fields = fields;

    if (excludes.length) {
      var keys = excludes.map(function (_ref) {
        var first = _ref[0];
        var second = _ref[1];
        return first + '-' + second;
      });

      next._excludedEdges = next._excludedEdges.concat(keys);
    }

    next._nodes = (0, _sortFields2.default)(fields, next._excludedEdges);

    return next;
  },
  from: function from(_from, to, alias) {
    return this.transform(function (obj) {
      var newObj = obj;

      if (obj == null) return obj;

      if ((0, _has2.default)(obj, _from)) {
        newObj = (0, _omit2.default)(obj, _from);
        newObj[to] = obj[_from];

        if (alias) newObj[_from] = obj[_from];
      }

      return newObj;
    });
  },
  noUnknown: function noUnknown() {
    var noAllow = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
    var message = arguments.length <= 1 || arguments[1] === undefined ? _locale.object.noUnknown : arguments[1];

    if (typeof noAllow === 'string') message = noAllow, noAllow = true;

    var next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test: function test(value) {
        return value == null || !noAllow || unknown(this.schema, value).length === 0;
      }
    });

    if (noAllow) next._options.stripUnknown = true;

    return next;
  },
  camelcase: function camelcase() {
    return this.transform(function (obj) {
      return obj && (0, _mapKeys2.default)(obj, function (_, key) {
        return camelize(key);
      });
    });
  },
  constantcase: function constantcase() {
    return this.transform(function (obj) {
      return obj && (0, _mapKeys2.default)(obj, function (_, key) {
        return _case2.default.constant(key);
      });
    });
  }
});

ObjectSchema.prototype.camelCase = ObjectSchema.prototype.camelcase;
ObjectSchema.prototype.constantCase = ObjectSchema.prototype.constantcase;


//////////////////
// WEBPACK FOOTER
// ./~/yup/lib/object.js
// module id = 1505
// module chunks = 0